import { type Infer, v } from "convex/values";

export const orderStageValidator = v.union(
  v.literal("draft"),
  v.literal("pending_approval"),
  v.literal("awaiting_pickup"),
  v.literal("in_transit"),
  v.literal("delivered"),
  v.literal("completed"),
  v.literal("cancelled"),
  v.literal("refunded"),
);
export type OrderStage = Infer<typeof orderStageValidator>;

export const orderStageInputValidator = v.union(
  orderStageValidator,
  v.literal("pending"),
  v.literal("confirmed"),
  v.literal("in_fulfillment"),
);

export const orderPaymentStatusValidator = v.union(
  v.literal("pending_review"),
  v.literal("unpaid"),
  v.literal("awaiting_approval"),
  v.literal("invoiced"),
  v.literal("paid"),
  v.literal("refunded"),
  v.literal("failed"),
  v.literal("unknown"),
);
export type OrderPaymentStatus = Infer<typeof orderPaymentStatusValidator>;

export const orderFulfillmentStatusValidator = v.union(
  v.literal("pending"),
  v.literal("scheduled"),
  v.literal("in_transit"),
  v.literal("partial_delivery"),
  v.literal("delivered"),
);
export type OrderFulfillmentStatus = Infer<
  typeof orderFulfillmentStatusValidator
>;
